const HEADERS = {
    'X-Requested-With': 'XMLHttpRequest'
};

const SERVER_TIMEOUT = 290000;

/**
 * Extend native fetch to throw timeout error, otherwise it may hang forever
 *
 * @param { string } url - String url to fetch
 * @param { RequestInit } options - Fetch API RequestInitOptions
 * @param { number } timeout - Timeout in miliseconds.
 *
 * @returns { Promise<Response> }
 */
const fetchWithTimeout = (url: string, options: RequestInit, timeout: number = SERVER_TIMEOUT): Promise<Response> => {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Request timed out')), timeout);

        fetch(url, options)
            .then((response) => {
                clearTimeout(timer);
                resolve(response);
            })
            .catch((err) => {
                clearTimeout(timer);
                reject(err);
            });
    });
};

type Result<T> =
    | { ok: true; data: T }
    | { ok: false; error: Error };

export const fetchData = async <T>(
    input: RequestInfo | URL,
    method: string = 'GET',
    init?: RequestInit
): Promise<Result<T>> => {
    try {
        const response = await fetchWithTimeout(input, {
            method,
            headers: HEADERS,
            ...init
        });

        if (!response.ok) {
            return {
                ok: false,
                error: new Error(`HTTP error: ${response.status} ${response.statusText}`),
            };
        }

        const data: T = await response.json();
        return { ok: true, data };
    } catch (error) {
        return { ok: false, error: error instanceof Error ? error : new Error('Unknown server error') };
    }

};
